import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";

export const calorPeriodManagementRoute: RouteConfig<'with-page'> = {
    name: 'Manage Period',
    path: '/calor/periods/:periodId',
    page: lazy(() => import('.')),
    flags: ['no-menu-item'],
    roles: ['ncassAdmin'],
}